const RegExpressions = {
  GroupDetailsPath: /^\/groups\/[a-zA-Z]{2}-[0-9]{3}-[0-9]{3}\/details/,
};

export default RegExpressions;
